import React from "react";

import HeroBlock from "./HeroBlock";
import ProofBlock from "./ProofBlock";
import HighlightsBlock from "./HighlightsBlock";
import AchievementsGridBlock from "./AchievementsGridBlock";
import AboutTeaserBlock from "./AboutTeaserBlock";
import TextImageBlock from "./TextImageBlock";
import PageHeaderBlock from "./PageHeaderBlock";
import StatsRowBlock from "./StatsRowBlock";
import ImageRowBlock from "./ImageRowBlock";
import CtaBannerBlock from "./CtaBannerBlock";

const BLOCK_MAP = {
  "hero": HeroBlock,
  "proof": ProofBlock,
  "highlights": HighlightsBlock,
  "achievements-grid": AchievementsGridBlock,
  "about-teaser": AboutTeaserBlock,
  "text-image": TextImageBlock,
  "page-header": PageHeaderBlock,
  "stats-row": StatsRowBlock,
  "image-row": ImageRowBlock,
  "cta-banner": CtaBannerBlock,
};

export default function BlockRenderer({ blocks = [] }) {
  return (
    <>
      {blocks.map((block) => {
        const Component = BLOCK_MAP[block.type];
        if (!Component) return null;
        return <Component key={block.id} {...block} />;
      })}
    </>
  );
}
